import { Expose } from 'class-transformer'

export class BookBuyAllChapterPromotion {
  @Expose() startDate: string

  @Expose() endDate: string

  @Expose() discountPercentage: number
}
